module.exports = __webpack_public_path__ + "media/images/donation/logo-sony-af12294eb18eacb41d3b39af4aafb01e.jpg";